import React from 'react'
import "./ChallengeAvtiveLight.css";

/*
 * The status light used by the content list, the coaches' videos list, the
 * e-shop customers list and the events list. The props contract is unchanged:
 *
 *   isActive            1 -> live, 0 -> off
 *   AcceptParticipants  1 -> open, 0 -> closed  (optional)
 *
 * One behaviour fix: the old markup only drew something when
 * AcceptParticipants was explicitly 1 or 0, so every caller that passes only
 * `isActive` (the content list, coaches' videos, e-shop customers) rendered an
 * EMPTY cell for an active row. A missing AcceptParticipants now means "not
 * applicable" and the light reads the record's own active flag.
 *
 * Colour comes from tokens: --good, --accent (open but not accepting) and
 * --crit. Never red/green/orange keywords, which were invisible against the
 * dark theme's panel and identical for the two "on" states.
 */
export default function ChallengeActiveLight(props) {

  const active = props.isActive == 1
  const accepts = props.AcceptParticipants
  const gated = accepts !== undefined && accepts !== null && accepts != 1

  const tone = !active ? 'cal-crit' : gated ? 'cal-warn' : 'cal-good'
  const label = !active
    ? 'Inactive'
    : gated
      ? 'Active — entries closed'
      : 'Active'

  return (
    <span className="cal" title={label}>
      <span className={'cal-dot ' + tone} aria-hidden="true"></span>
      <span className="cal-sr">{label}</span>
    </span>
  )
}
